import React, { Children, useEffect, useState } from "react";
import "./Navbar.css";
import { useLocation } from "react-router-dom";
import { navbarIcons } from "../config/navbar.icons";
import { useDispatch, useSelector } from "react-redux";
import {
  setSidebarVisible,
  setLargeWindowSidebarVisible,
} from "../../services/slices/appConfig";

export default function TopNavBar({ children }) {
  const dispatch = useDispatch();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const location = useLocation()?.pathname.replaceAll("/", "");

  const navbarClassName = `navbar-v3 ${
    location === "configuration" ? "navbar-config" : ""
  }`;

  const hideSidebar = () => {
    dispatch(setSidebarVisible(false));
    setIsSidebarOpen(false);
  };

  const showSidebar = () => {
    dispatch(setSidebarVisible(true));
    setIsSidebarOpen(true);
  };

  return (
    <>
      <nav className={navbarClassName}>
        <div
          className="dashboard-icon"
          onClick={isSidebarOpen ? hideSidebar : showSidebar}
        >
          {navbarIcons.dashboardIcon}
        </div>
        <div className="ecp-icon-wrapper"></div>
        {children}
      </nav>
      {isSidebarOpen && (
        <div className="sidebar-overlay visible" onClick={hideSidebar}></div>
      )}
    </>
  );
}
